/* eslint-disable */
"use strict";
import errorService from "@/services/errorService";

var config, service, analisi, magazzino, inventario;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  analisi = config.VUE_APP_MOL_S_ANALYSIS
  magazzino = config.VUE_APP_MOL_S_WHAREHOUSE
  inventario = config.VUE_APP_MOL_S_INVENTORY
}

async function cicleSync(multiplo) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${magazzino}/cicleSync`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ multiplo }),
    });
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function getRunMode() {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${magazzino}/mode`);
    const result = await response.json();
    if (result.status === 404) {
      return defaultRunMode();
    }
    return result;
  } catch {
    return defaultRunMode();
  }
}

function defaultRunMode() {
  return {
    modulo: "MAGAZZINO",
    locale: "---",
    remote: "---",
    versione: "---",
    health: "---",
  };
}

async function creaMovimentiScontrino(
  tipo,
  magazzino,
  causale,
  righe,
  scontrino
) {
  if (!config || !service) {
    await getConfigFile();
  }
  // TODO: verificare come prendere magazzino e causale

  // const infoScontrino = { ...scontrino }
  // delete infoScontrino.righe --> passo anche le righe dello scontrino prchè potrebbe esserci un abbuono sul totale o qualche info sul pagamento
  var data = {
    magazzino,
    tipo,
    causale,
    righe,
    scontrino,
  };

  try {
    const response = await fetch(`${service}/${magazzino}/movimenti`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    errorService.onError(error, "creaMovimentiScontrino");
  }
}

// Su magazzino torna anche info prodotto e info caulase, su movimenti ritorna solo movimento secco
async function getMovimento(id) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${magazzino}/movimenti/${id}`);
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function creaMovimenti(movimento) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${magazzino}/movimenti`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(movimento),
    });
    const result = await response.json();
    if (response.status !== 200) {
      errorService.onError(result.message, "creaMovimenti");
      return false;
    }
    return result;
  } catch (error) {
    console.log(error);
    errorService.onError(error, "creaMovimenti");
    return false;
  }
}

// NON USATA
/* async function aggiornaMovimento(movimento) {
  try {
    const response = await fetch(`${service}/${magazzino}/movimenti/${movimento._id}/update`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(movimento)
    })
    return await response.json()
  } catch (error) {
    errorService.onError(error, 'aggiornaMovimento')
  }
}
 */
async function getMovimentiParametri(filtro, parametri) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      filtro,
      parametri,
    };
    const response = await fetch(`${service}/${analisi}/movimenti/parametri`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    return error;
  }
}

// non ancora implementata
async function getFilteredMovements(filtri, opzioni) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    opzioni,
  };
  console.log(data);
  try {
    const response = await fetch(`${service}/${magazzino}/movimenti/filter`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function getFilteredDetailMovements(filtri, opzioni) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    opzioni,
  };
  try {
    const response = await fetch(
      `${service}/${magazzino}/movimenti/dettaglio/filter`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function cancellaPerRiferimento(tipo, id, data) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    // const response = await fetch(`${service}/${magazzino}/riferimento/${tipo}/${encodeURIComponent(id)}/delete`, {
    const response = await fetch(
      `${service}/${magazzino}/movimenti/riferimento/${tipo}/${encodeURIComponent(
        id
      )}/delete${data ? "?data=" + encodeURIComponent(data) : ""}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      }
    );
    return await response.json();
  } catch (error) {
    // errorService.onError(error, 'cancellaMovimento')
  }
}

async function cancellaRigaPerRiferimento(tipo, id, data, codiceRiga) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    // const response = await fetch(`${service}/${magazzino}/riferimento/${tipo}/${encodeURIComponent(id)}/delete`, {
    const info = {
      data,
      codiceRiga,
    };
    const response = await fetch(
      `${service}/${magazzino}/movimenti/riferimento/${tipo}/${encodeURIComponent(
        id
      )}/delete/riga`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(info),
      }
    );
    return await response.json();
  } catch (error) {
    // errorService.onError(error, 'cancellaMovimento')
  }
}

/* *********************************************************************************************************************** */
/* *********************************************     GESTIONE INVENTARIO     ********************************************* */
/* *********************************************************************************************************************** */

async function importaInventarioLetture(
  nomeFile,
  tipoFile,
  settore,
  dataLettura,
  note,
  datiRaw,
  dati
) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    nomeFile,
    tipoFile,
    settore,
    data: dataLettura,
    note,
    datiRaw,
    dati,
  };
  try {
    const response = await fetch(
      `${service}/${inventario}/importazione/letture`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  } catch {}
}

async function getLettureInventario(filtri, opzioni) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    filtri,
    opzioni,
  };
  try {
    const response = await fetch(`${service}/${inventario}/letture`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function completaLetture(letturaId) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    letturaId,
  };
  try {
    const response = await fetch(`${service}/${inventario}/letture/completa`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function downloadInfoLetture(letturaId) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    letturaId,
  };
  try {
    const response = await fetch(`${service}/${inventario}/letture/info`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function comparaLetture(
  lettureSelezionate,
  categorieIncluse,
  categorieEscluse,
  dataGiacenza
) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    lettureSelezionate,
    categorieIncluse,
    categorieEscluse,
    dataGiacenza,
  };
  try {
    const response = await fetch(`${service}/${inventario}/letture/compara`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function prodottiNonContati(
  lettureSelezionate,
  categorieIncluse,
  categorieEscluse,
  dataGiacenza,
  dataMovimentati
) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    lettureSelezionate,
    categorieIncluse,
    categorieEscluse,
    dataGiacenza,
    dataMovimentati,
  };
  try {
    const response = await fetch(
      `${service}/${inventario}/letture/noncontati`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function creaMovimentiInventario(
  comparazione,
  tipoMovimento,
  magazzino,
  dataMovimento
) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    comparazione,
    tipoMovimento,
    magazzino,
    dataMovimento,
  };
  try {
    const response = await fetch(`${service}/${inventario}/movimenti`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function creaMovimentiInventarioNonContati(
  comparazione,
  tipoMovimento,
  magazzino,
  dataMovimento,
  letture
) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    comparazione,
    tipoMovimento,
    magazzino,
    dataMovimento,
    letture,
  };
  try {
    const response = await fetch(
      `${service}/${inventario}/movimenti/noncontati`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function creaMovimentoRettificaGiacenza(dati) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${inventario}/giacenza/movimento`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dati),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return null;
  }
}

async function scontriniFlatEsportazione(filtro, payload) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      filtro,
      payload,
    };
    const response = await fetch(
      `${service}/${analisi}/scontrini/esportazione`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return null;
  }
}

async function creaMovimentiMultipli(movimentiMultipli, tipo) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${magazzino}/movimenti/multipli${tipo ? "?tipo=pc" : ""}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(movimentiMultipli),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return null;
  }
}

/* 
async function inviaFileForm(form_data) {
  try {
    const response = await fetch(`${service}/${inventario}/send-file`, {
      method: 'POST',
      body: form_data
    })
    return  await response.text()
  } catch (err) {
    return err
  }
}

async function getFileList(tipo, filtro) {
  const response = await fetch(`${service}/${inventario}/dir/${tipo}?flt=${filtro}`)
  return await response.json()
}

async function deleteFile(file) {
  const data = {
    file
  }
  const response = await fetch(`${service}/${inventario}/dir/delete`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  return await response.json()
}
 */
export default {
  cicleSync,
  getRunMode,
  creaMovimentiScontrino,
  getMovimento,
  creaMovimenti,
  // aggiornaMovimento,
  getMovimentiParametri,
  getFilteredMovements,
  getFilteredDetailMovements,
  cancellaPerRiferimento,
  cancellaRigaPerRiferimento,
  importaInventarioLetture,
  getLettureInventario,
  completaLetture,
  downloadInfoLetture,
  comparaLetture,
  creaMovimentiInventario,
  creaMovimentiInventarioNonContati,
  prodottiNonContati,
  creaMovimentoRettificaGiacenza,
  scontriniFlatEsportazione,
  creaMovimentiMultipli,
  /*  inventarioLettureMemory,
  inviaFileForm,
  getFileList,
  deleteFile */
};
